import React, { useState } from "react";
import { api } from "../../lib/api";
import { mfaErr } from "../../lib/webauthn";
import { Button } from "../ui/button";
import StatusChip from "../StatusChip";

const STATE_TEXT = {
  active: "Active",
  available_to_activate: "Available to activate",
  not_implemented: "Not implemented",
  externally_blocked: "Externally blocked",
};

// One registry module. The switch appears only when the server says the change is allowed; otherwise the
// server's reason is shown (not implemented, externally blocked, core, dependency, env-forced).
export default function ModuleRow({ m, token, onDone }) {
  const [reason, setReason] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const enable = m.state !== "active";
  const check = enable ? m.activation : m.deactivation;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.put(`/admin/modules/${m.key}`, { enabled: enable, reason: reason.trim() }, { headers: { "X-MFA-StepUp": token } });
      setReason("");
      onDone(`${m.label}: ${enable ? "activated" : "deactivated"}. Recorded in the audit log.`);
    } catch (x) { setErr(mfaErr(x)); } finally { setBusy(false); }
  };
  return (
    <li className="border border-erf-borderCream rounded bg-white p-4 space-y-2" data-testid={`module-row-${m.key}`}>
      <div className="flex flex-wrap items-center gap-2 justify-between">
        <h2 className="font-display font-semibold text-sm sm:text-base">{m.label}</h2>
        <StatusChip status={m.state} label={STATE_TEXT[m.state]} testId={`module-state-${m.key}`} />
      </div>
      <p className="text-xs font-mono text-erf-dark/70">
        {m.phase ? `Phase ${m.phase}` : "Core"} · {m.gap_ref}{m.source ? ` · source: ${m.source}` : ""}
      </p>
      {m.depends_on.length > 0 && <p className="text-xs" data-testid={`module-deps-${m.key}`}>Needs: {m.depends_on.join(", ")}</p>}
      {(m.reason || m.note) && <p className="text-sm text-erf-dark/80">{m.reason || m.note}</p>}
      {err && <p role="alert" className="text-sm text-red-700" data-testid={`module-error-${m.key}`}>{err}</p>}
      {check.allowed ? (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 sm:items-end">
          <label htmlFor={`module-reason-${m.key}`} className="text-sm flex-1">Reason
            <input id={`module-reason-${m.key}`} value={reason} onChange={(e) => setReason(e.target.value)} maxLength={300}
              className="block mt-1 w-full min-h-[44px] rounded border border-erf-borderCream px-3" data-testid={`module-reason-${m.key}`} />
          </label>
          <Button type="submit" disabled={!token || busy || reason.trim().length < 3}
            className={`min-h-[44px] font-semibold ${enable ? "bg-erf-gold text-erf-dark" : "bg-erf-dark text-white"}`}
            data-testid={`module-switch-${m.key}`}>{enable ? "Activate" : "Deactivate"}</Button>
        </form>
      ) : (
        <p className="text-xs text-erf-dark/60" data-testid={`module-locked-${m.key}`}>{check.message}</p>
      )}
    </li>
  );
}
